module.exports = __webpack_public_path__ + "static/img/index-nav-4.ba648b83.png";